import type { ProductResponseDto } from "@/api/api-client"

import type { InventoryStatusFilter } from "./inventory-types"

export function isLowStockProduct(product: ProductResponseDto) {
  return product.stockQuantity <= (product.lowStockThreshold || 5)
}

export function isCriticalStockProduct(product: ProductResponseDto) {
  return product.stockQuantity <= (product.safetyStockLevel || 0)
}

export function shouldReorderProduct(product: ProductResponseDto) {
  return product.reorderPoint > 0 && product.stockQuantity <= product.reorderPoint
}

export function getInventoryMargin(product: ProductResponseDto) {
  if (product.price <= 0) return 0
  return ((product.price - (product.unitCost || 0)) / product.price) * 100
}

export function filterInventoryProducts(
  products: ProductResponseDto[] | undefined,
  statusFilter: InventoryStatusFilter
) {
  if (!products) return []

  switch (statusFilter) {
    case "low":
      return products.filter((product) => isLowStockProduct(product) && product.stockQuantity > 0)
    case "out":
      return products.filter((product) => product.stockQuantity <= 0)
    default:
      return products
  }
}
